import React from 'react';
import { func, array, string } from 'prop-types';
import styled from 'styled-components';

import { Label, Icon } from 'semantic-ui-react';

const Container = styled.div`
    display: flex;
    padding: 20px 20px 12px 20px;
    align-items: flex-start;
    border-top: 1px solid ${p => p.theme.color.starkiller};
    flex-wrap: wrap;
`;

const StyledHeader = styled.h2`
    font-size: 16px;
    padding-top: 5px;
    margin-right: 4px;
`;


const SelectedItems = ({
    items,
    title,
    onDeleteItem,
}) => (
    <Container>
        {
            title && <StyledHeader as="h4">{ title }</StyledHeader>
        }
        {
            items.length > 0 ? (
                items.map((e) => {
                    const { name, id } = e;
                    return (
                        <Label key={id} size="large" style={{ marginBottom: 6 }}>
                            { name }
                            <Icon name="delete" onClick={() => onDeleteItem(e)} />
                        </Label>
                    );
                })
            ) : <Label basic size="large"> None </Label>
        }
    </Container>
);


SelectedItems.propTypes = {
    items: array,
    onDeleteItem: func,
    title: string,
};

SelectedItems.defaultProps = {
    items: [],
};

export default SelectedItems;
